import { createContext, ReactNode, useState } from 'react'
import { IHeader } from 'core/interface/header'

interface ICurrentHeaderContextType {
  header: IHeader
  setHeader: (value: IHeader) => void
}

export const CurrentHeaderContext = createContext<ICurrentHeaderContextType>({
  header: {
    svgPath: '',
    svgPathDark: '',
    accroche: '',
    column: true,
  },
  setHeader: () => {},
})

export const CurrentHeaderProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [header, setHeader] = useState<IHeader>({
    svgPath: 'logoIaDocs.svg',
    svgPathDark: 'logoIaDocsDark.svg',
    accroche: 'iadocs.accroche',
    column: true,
  })

  return (
    <CurrentHeaderContext.Provider
      value={{
        header,
        setHeader,
      }}
    >
      {children}
    </CurrentHeaderContext.Provider>
  )
}
